// extracted by mini-css-extract-plugin
export default {"home":"ExamDetails_home__GC6Pp","home2":"ExamDetails_home2__4iD90","hr":"ExamDetails_hr__Q-JIT","main":"ExamDetails_main__6MWeo"};